// src/pages/Today.js
import React, { useState, useEffect } from "react";
import Typography from "./Typography";
import { spacing } from "../utils/tokens";
import { useTheme } from "../context/ThemeContext";
import { useQueue } from "../context/QueueContext";

import Header from "./Header";
import ArticleCard from "./ArticleCard";
import { color } from "framer-motion";

function CompanyName ({
    name = '',
    symbol = '',
    logo = ''
}){
    const { theme } = useTheme(); 
    const fallbackLogoUrl = "https://static.vecteezy.com/system/resources/thumbnails/008/695/917/small_2x/no-image-available-icon-simple-two-colors-template-for-no-image-or-picture-coming-soon-and-placeholder-illustration-isolated-on-white-background-vector.jpg"; // Replace with a real fallback logo


    const fullLogoUrl = logo && logo.includes("api.polygon.io") 
    ? `${logo}?apiKey=${process.env.REACT_APP_POLYGON_API_KEY}` 
    : logo || fallbackLogoUrl;


    const styles = {
        container: {
            display: "flex",
            height: "100%",
            overflow: "hidden",
            backgroundColor: theme.colors.background,
            color: theme.colors.text,
            padding: `${spacing.l}px ${spacing.m}px ${spacing.m}px ${spacing.m}px`,
            boxSizing: "border-box",
            justifyContent:"space-between",
            alignItems: "flex-start"
        },
        textContainer:{
            display: "flex",
            flexDirection: "column",
            gap: spacing.s,
        },
        captionContainer:{
            display: "flex",
            gap: spacing.s,
            color: theme.colors.contentSecondary
        },
        logoContainer: {
            width: "44px",
            height: "44px",
            flexShrink: 0,             // <--- prevents parent flex from shrinking it
            borderRadius: "50%",       // <--- perfect circle
            overflow: "hidden",        // <--- ensures the image doesn’t spill out
            backgroundColor: theme.colors.fillSecondary,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        logoImage: {
            width: "44px",
            height: "auto",          // automatically scales image height
            display: "block",
            borderRadius: "50%",       // match container for perfect circle
        },
    };
    

    return (
        <div style={styles.container}>
            <div style={styles.textContainer}>
                <div style={styles.captionContainer}>
                    <Typography variant="supportingCaption" type="editorial">{symbol}</Typography>
                    <Typography variant="supportingCaption" type="editorial">&#183;</Typography>
                    <Typography variant="supportingCaption" type="editorial">NASDAQ</Typography>
                </div>
                <Typography variant="headlineMedia" type="editorial" style={{fontSize: "24px", fontWeight: 500, lineHeight: "normal"}}>{name}</Typography>
            </div>
            <div style={styles.logoContainer}>
                <img src={fullLogoUrl} alt="Company Logo" style={styles.logoImage}/>
            </div>
        </div>
        
    )
}

export default CompanyName;